import { useState } from 'react';
import { CheckinFlowModal } from './CheckinFlowModal';
import type { BookingRow, LifecycleStatus } from '../types';

interface Props {
  booking: BookingRow;
  onChanged?: (next: LifecycleStatus) => void;
}

// Manual check-in button. Both the QR-scan path (ScanScreen) and this manual
// path now route through CheckinFlowModal so the operator gets the same
// confirmation step + early-arrival picker. The modal calls the same
// /booking-checkin endpoint underneath for one consistent audit + lifecycle
// codepath; manual passes booking_id, scan passes qr_token.
export function CheckinButton({ booking, onChanged }: Props) {
  const [open, setOpen] = useState(false);

  if (booking.lifecycle_status === 'arrived') {
    return <span className="checkin-done">✓ Aangekomen</span>;
  }
  if (booking.lifecycle_status === 'cancelled') {
    return <span className="checkin-blocked">Geannuleerd</span>;
  }

  return (
    <>
      <button className="btn-primary" onClick={() => setOpen(true)}>
        Check in
      </button>
      {open ? (
        <CheckinFlowModal
          bookingId={booking.id}
          onClose={(changed) => {
            setOpen(false);
            if (changed) onChanged?.('arrived');
          }}
        />
      ) : null}
    </>
  );
}
